import { render, staticRenderFns } from "./budget.vue?vue&type=template&id=8cc25458&"
import script from "./budget.vue?vue&type=script&lang=ts&"
export * from "./budget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports